import fb from '@/firebaseConfig';
import localStore from '@/utils/LocalStore';

/*
 *  NON-SUBSCRIBERS:
 *  - Will see all cards in card lists, but premium cards have a lock next to them
 *  - Clicking a premium card will open Plus promo
 *  - When swiping through cards, won't see premium cards
 *
 */

/*

  STATE

 */

const state = {
  allCards: {},
  journeyIds: [], // Only cards user has access to
  journeyIdsForList: [], // All cards, including premium cards for non-subscribers
  deepeningIds: [],
  deepeningIdsForList: [],
  lighteningIds: [],
  lighteningIdsForList: [],
  recentIds: [],
  isLoaded: false,
};

/*

  GETTERS

 */

const getters = {};

/*

  ACTIONS

 */

const actions = {
  init({ dispatch }, { isMember }) {
    // const { isSignedIn } = rootState.auth;
    // const { isLoaded } = state;

    // if (isSignedIn && !isLoaded) {
    dispatch('fetchCards', isMember);
    // }
  },

  async fetchCards({ commit, dispatch, rootState }, isMember) {
    // const { isMember } = rootState.user;
    try {
      const docs = await fb.cardsCollection.orderBy('title').get();

      const allCards = {};
      const journeyIds = [];
      const journeyIdsForList = [];
      const deepeningIds = [];
      const deepeningIdsForList = [];
      const lighteningIds = [];
      const lighteningIdsForList = [];

      docs.forEach(doc => {
        const { id } = doc;
        const data = doc.data();
        const { category, isPremium } = data;

        const userCanAccess = !isPremium || isMember;
        allCards[id] = { ...data, userCanAccess };

        if (category === 'journey') {
          journeyIdsForList.push(id);
          if (userCanAccess) journeyIds.push(id);
        } else if (category === 'deepening') {
          deepeningIdsForList.push(id);
          if (userCanAccess) deepeningIds.push(id);
        } else if (category === 'lightening') {
          lighteningIdsForList.push(id);
          if (userCanAccess) lighteningIds.push(id);
        }
      });

      commit('setCardsAndCategories', {
        allCards,
        journeyIds,
        journeyIdsForList,
        deepeningIds,
        deepeningIdsForList,
        lighteningIds,
        lighteningIdsForList,
      });

      dispatch('dailyCards/init', null, { root: true });
      dispatch('loadRecentIds');
    } catch (error) {
      console.error('Error fetching cards: ', error);
    }
  },

  async loadRecentIds({ commit, state }) {
    const savedIds = await localStore.getItem('recentCardIds');
    if (!state.recentIds.length) {
      commit('setRecentIds', savedIds || []);
    }
  },

  async addToRecentIds({ commit, state }, cardId) {
    let recentIds = [...state.recentIds];
    if (!recentIds.length) {
      recentIds = (await localStore.getItem('recentCardIds')) || [];
    }
    const index = recentIds.indexOf(cardId);
    if (index > -1) recentIds.splice(index, 1);
    const newRecentIds = [cardId, ...recentIds].slice(0, 8);
    commit('setRecentIds', newRecentIds);
    localStore.setItem('recentCardIds', newRecentIds);
  },

  clearRecentIds() {
    localStore.setItem('recentCardIds', []);
  },

  // getRandomCard({ state, getters }, category) {
  //   const set = state[`${category}Ids`] || state.currentSet;
  //   const randomIndex = Math.floor(Math.random() * set.length);
  //   const randomId = set[randomIndex];
  //   return {
  //     cardId: randomId,
  //     index: randomIndex,
  //     set,
  //   };
  // },
};

/*

  MUTATIONS

 */

const mutations = {
  setCardsAndCategories(state, data) {
    const {
      allCards,
      journeyIds,
      journeyIdsForList,
      deepeningIds,
      deepeningIdsForList,
      lighteningIds,
      lighteningIdsForList,
    } = data;

    state.allCards = allCards;
    state.journeyIds = journeyIds;
    state.journeyIdsForList = journeyIdsForList;
    state.deepeningIds = deepeningIds;
    state.deepeningIdsForList = deepeningIdsForList;
    state.lighteningIds = lighteningIds;
    state.lighteningIds = lighteningIds;
    state.lighteningIdsForList = lighteningIdsForList;
    state.isLoaded = true;
  },

  setRecentIds(state, recentIds) {
    state.recentIds = recentIds;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
